import {
  hasClass,
  addClass,
  removeClass
} from '../utilities/dom';

export default class {
  constructor({
    handle,
  }) {
    const lists = document.querySelectorAll(`.${handle}`);

    Array.from(lists).forEach(list => {
      const tabs = list.querySelectorAll('.tabs__item');
      const contents = list.querySelectorAll('.tabs__item__content');
      const contentContainer = list.querySelector('.tabs__details');
      const mobileTriggers = list.querySelectorAll('.tabs__item__content-title');

      function setActiveTab(tab) {
        const tabActive = list.querySelector('.active');
        if (tabActive) {
          removeClass(tabActive, 'active');
        }
        addClass(tab, 'active');
      }

      function setActiveContent(tabTarget) {
        const contentActive = contentContainer.querySelector('.active');
        removeClass(contentActive, 'active');
        Array.from(contents).forEach(content => {
          const contentId = content.getAttribute('id');
          if ('#' + contentId === tabTarget) {
            addClass(content, 'active');
          }
        });
      }

      Array.from(tabs).forEach(tab => {
        tab.addEventListener('click', event => {
          event.preventDefault();
          const tabLink = tab.querySelector('.tabs__item__title');
          const tabTarget = tabLink.getAttribute('href');
          if (!hasClass(tab, 'active')) {
            setActiveTab(tab);
            setActiveContent(tabTarget);
          }
        });
      });

      Array.from(mobileTriggers).forEach(trigger => {
        trigger.addEventListener('click', event => {
          const openTriggers = list.querySelectorAll('.tabs__item__toggle:checked');
          const triggerID = trigger.previousElementSibling.getAttribute('id');
          Array.from(openTriggers).forEach(openTrigger => {
            const openTriggerID = openTrigger.getAttribute('id');
            if (openTriggerID !== triggerID) {
              openTrigger.checked = false;
            }
          });
          setTimeout(() => {
            const triggerOffset = trigger.parentNode.getBoundingClientRect().top + window.scrollY;
            const windowOffset = triggerOffset - 80;
            window.scroll(0, windowOffset);
          }, 500);
        });
      });

      /**
       * Progressively style steps into tab-list on desktop
       */
      const styleTabs = () => {
        addClass(list, 'progressive');
      }

      styleTabs();
    })
  }
}